(function () {
    'use strict';

    angular.module("imApp").factory("tailorAccessService", ['$ihttp', function ($ihttp) {
        let service = {
            getTailorAccess: function (parms) {
                return $ihttp.post({
                    method: 2096,
                    parameters: parms || {}
                });
            },
            saveObj: function (editTailoredAccess) {
                return $ihttp.post({
                    method: 2097,
                    parameters: editTailoredAccess
                });
            },
            deleteObj: function (editTailoredAccess) {
                return $ihttp.post({
                    method: 2106,
                    parameters: editTailoredAccess
                });
            }
        };

        return service;
    }]);
})();
